<template>
  <div class="auth-wrapper d-flex no-block justify-content-center align-items-center" style="">
    <div class="auth-box">
      <div id="notifyform">
        <div class="logo">
          <span class="db"><img src="../../../assets/images/logo/logo-dark.png" alt="logo"></span>
          <h5 class="font-medium m-t-40 m-b-20">
            Registrations are not open to public yet. Signup here to be invited.
          </h5>
        </div>
        <!-- Form -->
        <div class="row">
          <div class="col-12">
            <form class="form-horizontal m-t-20" @submit.prevent="signup">
              <div class="form-group row ">
                <div class="col-12 ">
                  <input v-model="credentials.name" v-validate="'required'" class="form-control form-control-lg" type="text" placeholder="Name" name="name" data-vv-as="Name" :class="{ 'validate-error': errors.has('name') }">
                  <div v-if="errors.has('credentials.name')" class="help-block">
                    {{ errors.first('credentials.name') }}
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-12 ">
                  <input v-model="credentials.email" v-validate="'required|email'" class="form-control form-control-lg" type="text" placeholder="Email" name="email">
                  <span v-if="errors.has('credentials.email')" class="help-block">{{ errors.first('credentials.email') }}</span>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-12 ">
                  <div class="custom-control custom-checkbox">
                    <input id="terms" type="checkbox" class="custom-control-input">
                    <label class="custom-control-label" for="terms">I agree to AcreCX <a href="https://www.acrecx.com/terms" target="_blank">terms &amp; conditions</a></label>
                  </div>
                </div>
              </div>
              <div class="form-group text-center ">
                <div class="col-xs-12 p-b-20 ">
                  <button class="btn btn-block btn-lg btn-info " type="submit">
                    Join Waitlist
                  </button>
                </div>
              </div>
              <div class="form-group m-b-0 m-t-10 ">
                <div class="col-sm-12 text-center ">
                  Have an account?
                  <router-link :to="{ name: 'login'}" class="text-info m-l-5">
                    <b>Login here</b>
                  </router-link>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Signup',
  data () {
    return {
      loading: false,
      credentials: {
        name: '',
        email: ''
      },
      loggingIn: false,
      error: ''
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      $('[data-toggle="tooltip"]').tooltip()
      $('.preloader').fadeOut()

      $('#to-recover').on('click', function () {
        $('#notifyform').slideUp()
        $('#recoverform').fadeIn()
      })
    },
    signup () {
      const self = this
      this.$validator.validateAll()
        .then(result => {
          if (result) {
            self.loading = true
            this.$api.post('/signup', { name: this.credentials.name, email: this.credentials.email })
              .then(() => this.signupSuccessful())
              .catch(err => this.signupFailed(err))
          }
        })
    },
    signupSuccessful () {
      this.loading = false
      this.$swal({
        type: 'success',
        title: 'Thank You!',
        text: 'We have received your info. We will send ou an invite soon.',
        timer: 5000
      })
    },
    signupFailed (err) {
      this.loading = false

      const data = err.response.data
      this.$swal({
        type: 'error',
        title: 'Authentication Error',
        text: data.description || data.detail,
        timer: 5000
      })
    }
  }
}
</script>

<style scoped>
.auth-wrapper {
  background: linear-gradient(
      0deg,
      rgba(54, 64, 78, 0.75),
      rgba(54, 64, 78, 0.75)
    ),
    url(../../../assets/images/big/harvest.jpg);
  background-size: cover;
}
</style>
